import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import './css/HeaderMain.scss';
import navitems from "../../navitems.json";

function findComponentBySlug(slug) {
    // Search in main items
    const foundItem = navitems.find(item => item.slug === slug);
    if (foundItem) {
        return foundItem;
    }

    // Search in subitems
    for (const item of navitems) {
        const foundSubItem = item.subitem.find(subitem => subitem.slug === slug);
        if (foundSubItem) {
            return foundSubItem;
        }
    }

    return null; // Not found
}


class HeaderMain extends React.Component {
    render() {
        const {slug} = this.props;
        const item = findComponentBySlug(slug);

        return (
            <Container className="header">
                <Row>
                    <Col><h1>{item.name}</h1></Col>
                </Row>
            </Container>
        ); 
    }
}

export default HeaderMain;